module.exports = __webpack_public_path__ + "static/img/pdf.5dd4fa9c.png";